var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "dropdown-list-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v("Alan Etiketi")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.fieldLabel,
            expression: "fieldLabel",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "field-label",
          placeholder: "Bir soru girin",
        },
        domProps: { value: _vm.fieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.fieldLabel = $event.target.value
            },
            function ($event) {
              return _vm.setFieldLabel(_vm.fieldLabel)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v("Placeholder")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.placeholder,
            expression: "placeholder",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "field-label",
          placeholder: "Lütfen Seçim Yapınız",
        },
        domProps: { value: _vm.placeholder },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.placeholder = $event.target.value
            },
            function ($event) {
              return _vm.setplaceholder(_vm.placeholder)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Etiket Hizalama")]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.labelAlign === "left" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("left")
              },
            },
          },
          [_vm._v("SOL")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.labelAlign === "right" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("right")
              },
            },
          },
          [_vm._v("SAĞ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.labelAlign === "top" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("top")
              },
            },
          },
          [_vm._v("ÜST")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "checkbox-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.defaultAlign,
              expression: "defaultAlign",
            },
          ],
          staticClass: "checkbox",
          attrs: { type: "checkbox", id: "default-align" },
          domProps: {
            checked: Array.isArray(_vm.defaultAlign)
              ? _vm._i(_vm.defaultAlign, null) > -1
              : _vm.defaultAlign,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.defaultAlign,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.defaultAlign = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.defaultAlign = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.defaultAlign = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "checkbox-label", attrs: { for: "default-align" } },
          [_vm._v("Varsayılan olarak ayarla")]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Etiket metninin yatay olarak nasıl hizalanacağını seçin"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Zorunlu")]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.isRequired },
            on: { click: _vm.toggleRequired },
          },
          [_vm._v(_vm._s(_vm.isRequired ? "AÇIK" : "KAPALI"))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu alan boşsa formun gönderilmesine izin vermeyin"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Alt Etiket")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.altLabel,
            expression: "altLabel",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          placeholder: "Alanının altına kısa bir açıklama ekleyin",
        },
        domProps: { value: _vm.altLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.altLabel = $event.target.value
            },
            function ($event) {
              return _vm.setAltLabel(_vm.altLabel)
            },
          ],
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }